module.exports = __webpack_public_path__ + "static/media/511.5f294bb5.jpg";